<template>
  <div>
    <div class="icerik" style="height: calc(100vh - 0px);">
      <div class="SpotlightKutu" style="z-index: 1">
        <div class="input">
          <el-input
            :disabled="lo"
            placeholder="Unvan, Telefon veya Mail ile arama yapın, tamamı için boş bırakın (ENTER'A BASIN)"
            v-model="Kelime"
            @keyup.enter.native="Getir">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-table
        v-if="Liste"
        :data="Liste"
        class="golgetable"
        @current-change="TableSecim"
        :height="Height">
        <el-table-column
          label="Ünvan"
          prop="Unvan">
        </el-table-column>
        <el-table-column
          label="Email"
          prop="EMail"
          width="200">
        </el-table-column>
        <el-table-column
          label="Telefon"
          prop="Telefon"
          width="120">
        </el-table-column>
        <el-table-column
          align="right"
          width="250"
          label="Şehir"
          prop="Sehir"
        >

        </el-table-column>
      </el-table>
    </div>
    <MusteriDetayModal v-if="ModalOlayi" :ModalOlayi="ModalOlayi" @ModalOlayi="SayfaYukle"
                       :data="Musteri_id"></MusteriDetayModal>
  </div>
</template>

<script>
import MusteriDetayModal from "./comp/MusteriDetayModal";
import Yukleniyor from "../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, MusteriDetayModal},
  data() {
    return {
      lo: false,
      Aidatim: false,
      Liste: null,
      Kelime: '',
      search: '',
      Musteri_id: null,
      ModalOlayi: false,
      Height: window.innerHeight - 130
    }
  },
  methods: {
    TableSecim(val) {
      this.ModalOlayi = true;
      this.Musteri_id = val.id
    },
    Ekran(id) {
      this.ModalOlayi = true;
      this.Musteri_id = id
    },
    SayfaYukle() {
      this.ModalOlayi = false;
    },
    Getir() {
      this.ModalOlayi = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: '_a/liste/'+this.Kelime})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
          }
        });
    }
  },
  created() {
    this.Aidatim = localStorage.getItem('_airoot');
    if (this.Aidatim) {
      this.SayfaYukle();
    } else {
      this.$router.push('/panel');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_a/Hesap.vue